"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconPencilFilled = function IconPencilFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.1197 18.6872L31.3128 23.8816L19.1931 36H14V30.8057L26.1197 18.686V18.6872ZM27.8507 16.9562L30.4472 14.3584C30.6769 14.1289 30.9882 14 31.3128 14C31.6374 14 31.9487 14.1289 32.1782 14.3584L35.6415 17.8217C35.8711 18.0513 36 18.3626 36 18.6872C36 19.0119 35.8711 19.3232 35.6415 19.5528L33.0438 22.1493L27.8507 16.9562Z",
    fill: color
  }));
};

IconPencilFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconPencilFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconPencilFilled;
exports.default = _default;